import { SceneScheduleDaysWithCount } from './scene-schedule-days-with-count.model';
import { SceneScheduleStartEndTimes } from './scene-schedule-start-end-times.model';

export class SceneSchedule
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);

            if (json.Days)
            {
                this.Days = new SceneScheduleDaysWithCount(json.Days);
            }

            if (json.Time1)
            {
                this.Time1 = new SceneScheduleStartEndTimes(json.Time1);
            }

            if (json.Time2)
            {
                this.Time2 = new SceneScheduleStartEndTimes(json.Time2);
            }

            return;
        }

        this.Days = new SceneScheduleDaysWithCount();
        this.Time1 = new SceneScheduleStartEndTimes();
        this.Time2 = new SceneScheduleStartEndTimes();
    }

    public Name: string;
    public Enabled: boolean;
    public Days: SceneScheduleDaysWithCount;
    public Time1: SceneScheduleStartEndTimes;
    public Time2: SceneScheduleStartEndTimes;
}
